// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__2UpXi","head":"ProcedureTableInfo_head__1embj"};